module.exports = __webpack_public_path__ + "img/tag_new-release.3401b0c7.png";